import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "form" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10 card-bordered" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "card-title fs-3 fw-bold" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex my-4"
}
const _hoisted_6 = { class: "me-0" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "row mb-8" }
const _hoisted_9 = { class: "col-lg-3" }
const _hoisted_10 = { class: "col-lg-9 fv-row fv-plugins-icon-container d-flex align-items-center" }
const _hoisted_11 = {
  key: 0,
  class: "fw-bold fs-6 text-gray-800"
}
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "row mb-8" }
const _hoisted_14 = { class: "col-lg-3" }
const _hoisted_15 = { class: "col-lg-9 fv-row fv-plugins-icon-container d-flex align-items-center" }
const _hoisted_16 = {
  key: 0,
  class: "fw-bold fs-6 text-gray-800"
}
const _hoisted_17 = { class: "row mb-8" }
const _hoisted_18 = { class: "col-lg-3" }
const _hoisted_19 = { class: "col-lg-9 fv-row fv-plugins-icon-container d-flex align-items-center" }
const _hoisted_20 = {
  key: 0,
  class: "fw-bold fs-6 text-gray-800",
  style: {"white-space":"pre-line"}
}
const _hoisted_21 = { class: "row mb-8" }
const _hoisted_22 = { class: "col-lg-3" }
const _hoisted_23 = { class: "col-lg-9 fv-row fv-plugins-icon-container d-flex align-items-center" }
const _hoisted_24 = {
  key: 0,
  class: "fw-bold fs-6 text-gray-800",
  style: {"white-space":"pre-line"}
}
const _hoisted_25 = { class: "row mb-8" }
const _hoisted_26 = { class: "col-lg-3" }
const _hoisted_27 = { class: "col-lg-9 fv-row fv-plugins-icon-container d-flex align-items-center" }
const _hoisted_28 = {
  key: 0,
  class: "fw-bold fs-6 text-gray-800",
  style: {"white-space":"pre-line"}
}
const _hoisted_29 = { class: "row mb-8" }
const _hoisted_30 = { class: "col-lg-3" }
const _hoisted_31 = { class: "col-lg-9 fv-row fv-plugins-icon-container d-flex align-items-center" }
const _hoisted_32 = {
  key: 0,
  class: "fw-bold fs-6 text-gray-800"
}
const _hoisted_33 = {
  key: 0,
  class: "card-footer d-flex justify-content-end py-6"
}
const _hoisted_34 = ["data-kt-indicator", "disabled"]
const _hoisted_35 = { class: "form" }
const _hoisted_36 = { class: "card mb-5 mb-xl-10 card-bordered" }
const _hoisted_37 = { class: "card-header" }
const _hoisted_38 = { class: "card-title fs-3 fw-bold" }
const _hoisted_39 = {
  key: 0,
  class: "d-flex my-4"
}
const _hoisted_40 = { class: "me-0" }
const _hoisted_41 = { class: "card-body" }
const _hoisted_42 = { class: "row mb-8" }
const _hoisted_43 = { class: "col-lg-3" }
const _hoisted_44 = { class: "col-lg-9 fv-row fv-plugins-icon-container d-flex align-items-center" }
const _hoisted_45 = {
  key: 0,
  class: "fw-bold fs-6 text-gray-800",
  style: {"white-space":"pre-line"}
}
const _hoisted_46 = { class: "row mb-8" }
const _hoisted_47 = { class: "col-lg-3" }
const _hoisted_48 = { class: "col-lg-9 fv-row fv-plugins-icon-container d-flex align-items-center" }
const _hoisted_49 = {
  key: 0,
  class: "fw-bold fs-6 text-gray-800",
  style: {"white-space":"pre-line"}
}
const _hoisted_50 = { class: "row mb-8" }
const _hoisted_51 = { class: "col-lg-3" }
const _hoisted_52 = { class: "col-lg-9 fv-row fv-plugins-icon-container d-flex align-items-center" }
const _hoisted_53 = {
  key: 0,
  class: "fw-bold fs-6 text-gray-800",
  style: {"white-space":"pre-line"}
}
const _hoisted_54 = {
  disabled: "",
  value: ""
}
const _hoisted_55 = ["value"]
const _hoisted_56 = { class: "row mb-8" }
const _hoisted_57 = { class: "col-lg-3" }
const _hoisted_58 = { class: "col-lg-9 fv-row fv-plugins-icon-container d-flex align-items-center" }
const _hoisted_59 = {
  key: 0,
  class: "fw-bold fs-6 text-gray-800",
  style: {"white-space":"pre-line"}
}
const _hoisted_60 = {
  disabled: "",
  value: ""
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("option", { value: "Huesca" }, "Huesca", -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("option", { value: "Teruel" }, "Teruel", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("option", { value: "Zaragoza" }, "Zaragoza", -1)
const _hoisted_64 = {
  key: 0,
  class: "card-footer d-flex justify-content-end py-6"
}
const _hoisted_65 = ["data-kt-indicator", "disabled"]
const _hoisted_66 = { class: "form" }
const _hoisted_67 = { class: "card mb-5 mb-xl-10 card-bordered" }
const _hoisted_68 = { class: "card-header" }
const _hoisted_69 = { class: "card-title fs-3 fw-bold" }
const _hoisted_70 = {
  key: 0,
  class: "d-flex my-4"
}
const _hoisted_71 = { class: "me-0" }
const _hoisted_72 = { class: "card-body" }
const _hoisted_73 = { class: "row mb-8" }
const _hoisted_74 = { class: "col-lg-3" }
const _hoisted_75 = { class: "col-lg-9 fv-row fv-plugins-icon-container d-flex align-items-center" }
const _hoisted_76 = {
  key: 0,
  class: "fw-bold fs-6 text-gray-800"
}
const _hoisted_77 = ["value"]
const _hoisted_78 = { class: "row mb-8" }
const _hoisted_79 = { class: "col-lg-3" }
const _hoisted_80 = { class: "col-lg-9 fv-row fv-plugins-icon-container d-flex align-items-center" }
const _hoisted_81 = {
  key: 0,
  class: "fw-bold fs-6 text-gray-800"
}
const _hoisted_82 = ["value"]
const _hoisted_83 = { class: "row mb-8" }
const _hoisted_84 = { class: "col-lg-3" }
const _hoisted_85 = { class: "col-lg-9 fv-row fv-plugins-icon-container d-flex align-items-center" }
const _hoisted_86 = {
  key: 0,
  class: "fw-bold fs-6 text-gray-800"
}
const _hoisted_87 = ["aria-label"]
const _hoisted_88 = { value: true }
const _hoisted_89 = { value: false }
const _hoisted_90 = {
  key: 0,
  class: "row mb-8"
}
const _hoisted_91 = { class: "col-lg-3" }
const _hoisted_92 = { class: "col-lg-9 fv-row fv-plugins-icon-container d-flex align-items-center" }
const _hoisted_93 = {
  key: 0,
  class: "fw-bold fs-6 text-gray-800"
}
const _hoisted_94 = { class: "flex-grow-1" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("span", {
  style: {"border":"none"},
  class: "form-control-solid input-group-text"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-euro-sign fs-2x" })
], -1)
const _hoisted_96 = { class: "row mb-8" }
const _hoisted_97 = { class: "col-lg-3" }
const _hoisted_98 = { class: "col-lg-9 fv-row fv-plugins-icon-container d-flex align-items-center" }
const _hoisted_99 = {
  key: 0,
  class: "fw-bold fs-6 text-gray-800"
}
const _hoisted_100 = ["aria-label"]
const _hoisted_101 = { value: true }
const _hoisted_102 = { value: false }
const _hoisted_103 = {
  key: 0,
  class: "card-footer d-flex justify-content-end py-6"
}
const _hoisted_104 = ["data-kt-indicator", "disabled"]
const _hoisted_105 = { class: "form" }
const _hoisted_106 = { class: "card mb-5 mb-xl-10 card-bordered" }
const _hoisted_107 = { class: "card-header" }
const _hoisted_108 = { class: "card-title fs-3 fw-bold" }
const _hoisted_109 = { class: "d-flex my-4" }
const _hoisted_110 = { class: "me-0" }
const _hoisted_111 = { class: "card-body px-2 px-md-8" }
const _hoisted_112 = ["download", "href"]
const _hoisted_113 = /*#__PURE__*/_createElementVNode("span", { class: "el-dropdown-link" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-sm btn-icon btn-light btn-active-light-primary"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fas fa-ellipsis-h" })
  ])
], -1)
const _hoisted_114 = ["download", "href"]
const _hoisted_115 = { class: "menu-link text-danger px-3" }

import CurrencyInput from "@/components/widgets/CurrencyInput.vue";
import comarcas from "@/core/data/comarcas";
import {
  municipios,
  municipiosProvinciasComarcas,
} from "@/core/data/municipiosProvinciasComarcas";
import { numeroMenoresOpcionesTodas } from "@/core/data/numeroMenores";
import { tipologiasFamiliaTodas } from "@/core/data/tipologiasFamilia";
import tratamientos from "@/core/data/tratamiento";
import { diffObjects } from "@/core/helpers/diffObjects";
import { handleError } from "@/core/helpers/errorHandler";
import { FamiliaEdicion } from "@/store/models/index";
import FamiliasModule from "@/store/modules/FamiliasModule";
import { IAMFile } from "@/types";
import { ElMessage } from "element-plus";
import moment from "moment";
import Swal from "sweetalert2";
import { ErrorMessage, Field, useField, useForm } from "vee-validate";
import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";
import * as Yup from "yup";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();

const store = useStore();
const moduleFamilias = getModule(FamiliasModule, store);
const uploader = ref<HTMLInputElement | null>(null);

const familiaSchema = Yup.object().shape({
  tratamiento: Yup.string()
    .required()
    .label(t("perfilInformacionTratamientoLabel")),
  nombre: Yup.string().required().label(t("perfilInformacionNombreLabel")),
  apellidos: Yup.string()
    .required()
    .label(t("perfilInformacionApellidosLabel")),
  dni: Yup.string().required().label(t("perfilInformacionDNILabel")),
  email: Yup.string()
    .required()
    .email()
    .matches(
      /^(")?(?:[^."])(?:(?:[.])?(?:[\w\-!#$%&'*+/=?^_`{|}~]))*\1@(\w[-\w]*\.){1,5}([A-Za-z]){2,9}$/,
      t("perfilInformacionEmailError")
    )
    .label(t("perfilInformacionEmailLabel")),
  telefono: Yup.string().required().label(t("perfilInformacionTelefonoLabel")),
  direccion: Yup.string().required().label(t("perfilDireccionDireccionLabel")),
  comarcaId: Yup.string().required().label(t("DireccionComarcaLabel")),
  provincia: Yup.string().required().label(t("DireccionProvinciaLabel")),
  localidad: Yup.string().required().label(t("DireccionLocalidadLabel")),
  tipologiaFamilia: Yup.string()
    .required()
    .label(t("perfilInformacionTipologiaFamiliasLabel")),
  numeroMenores: Yup.string()
    .required()
    .label(t("perfilInformacionNumeroMenoresLabel")),
  conIngresos: Yup.bool()
    .required()
    .label(t("perfilSituacionFamiliarConIngresosLabel")),
  ingresos: Yup.string().label(t("perfilSituacionFamiliarIngresosLabel")),
  familiaPrioritaria: Yup.bool()
    .required()
    .label(t("perfilSituacionFamiliarFamiliaPrioritariaLabel")),
  documentosEliminar: Yup.array(),
  documentosNuevos: Yup.array(),
});

const { handleSubmit, resetForm, values, meta } = useForm<
  Partial<FamiliaEdicion>
>({ validationSchema: familiaSchema });

const resetFormValues = () => {
  if (moduleFamilias.familia) {
    resetForm({
      values: {
        tratamiento: moduleFamilias.familia.tratamiento,
        nombre: moduleFamilias.familia.nombre,
        apellidos: moduleFamilias.familia.apellidos,
        dni: moduleFamilias.familia.dni,
        email: moduleFamilias.familia.email,
        telefono: moduleFamilias.familia.telefono,
        direccion: moduleFamilias.familia.direccion,
        localidad: moduleFamilias.familia.localidad,
        comarcaId: moduleFamilias.familia.comarcaId,
        provincia: moduleFamilias.familia.provincia,
        numeroMenores: moduleFamilias.familia.numeroMenores,
        tipologiaFamilia: moduleFamilias.familia.tipologiaFamilia,
        conIngresos: moduleFamilias.familia.conIngresos,
        ingresos: moduleFamilias.familia.ingresos,
        familiaPrioritaria: moduleFamilias.familia.familiaPrioritaria,
        documentosEliminar: [],
        documentosNuevos: [],
      },
    });
  }
};

const { value: comarcaId } = useField("comarcaId");
const { value: provincia } = useField("provincia");
const { value: localidad } = useField("localidad");

watch(
  () => localidad.value,
  (val) => {
    let registro = municipiosProvinciasComarcas.find(
      (f) => f.municipioNombre == val
    );
    // Asignamos automaticamente la provincia y comarca
    comarcaId.value = registro?.comarcaId;
    provincia.value = registro?.provinciaNombre; // En IAM el ID de provincia es el nombre
  }
);

const fetchFamilia = async () => {
  try {
    resetFormValues();
    moduleFamilias.setDetailData(null);
    await moduleFamilias.fetch();
  } catch (error) {
    handleError(error);
  }
};

const documentosLoading = ref<boolean>(false);
const fetchFamiliaDocumentos = async () => {
  try {
    documentosLoading.value = true;
    if (moduleFamilias.documentos.length > 0) {
      moduleFamilias.setDocumentosData([]);
    }
    await moduleFamilias.fetchFamiliaDocumentos();
    documentosLoading.value = false;
  } catch (error) {
    documentosLoading.value = false;
    handleError(error);
  }
};

onMounted(async () => {
  await Promise.all([fetchFamilia(), fetchFamiliaDocumentos()]);
});
const familia = computed(() => moduleFamilias.familia);
const documentos = computed(() => moduleFamilias.documentos);

const { value: documentosEliminar } = useField<string[]>("documentosEliminar");
const { value: documentosNuevos } = useField<IAMFile[]>("documentosNuevos");

const formatLongDate = (row, column, cellValue) => {
  return moment(cellValue).locale("es").format("DD/MM/YYYY");
};

const familiaTratamiento = computed(() => {
  const result = tratamientos.find(
    (tr) => tr.id === familia.value?.tratamiento
  );
  return result ?? tratamientos[3];
});
const familiaTipologiaFamilia = computed(() => {
  const result = tipologiasFamiliaTodas.find(
    (tr) => tr.id === familia.value?.tipologiaFamilia
  );
  return result ?? tipologiasFamiliaTodas[6];
});
const familiaNumeroMenores = computed(() => {
  const result = numeroMenoresOpcionesTodas.find(
    (tr) => tr.id === familia.value?.numeroMenores
  );
  return result ?? numeroMenoresOpcionesTodas[9];
});

const editingInformacion = ref<boolean>(false);
const editingDireccion = ref<boolean>(false);
const editingSituacionFamiliar = ref<boolean>(false);
const savingForm = ref<boolean>(false);

watch([editingInformacion, editingDireccion, editingSituacionFamiliar], () => {
  resetFormValues();
});

const submit = handleSubmit(async (values) => {
  savingForm.value = true;
  values.ingresos = values.ingresos?.toString();
  const update = diffObjects<Partial<FamiliaEdicion>>(
    [
      "tratamiento",
      "nombre",
      "apellidos",
      "dni",
      "email",
      "telefono",
      "direccion",
      "localidad",
      "comarcaId",
      "provincia",
      "numeroMenores",
      "tipologiaFamilia",
      "conIngresos",
      "ingresos",
      "familiaPrioritaria",
      "documentosEliminar",
      "documentosNuevos",
    ],
    meta.value.initialValues as FamiliaEdicion,
    values
  ) as Partial<FamiliaEdicion>;

  try {
    await moduleFamilias.update(update);
    savingForm.value = false;
    await Promise.all([fetchFamilia(), fetchFamiliaDocumentos()]);

    ElMessage.success(t("perfilEdicionSuccessText"));
    editingInformacion.value = false;
    editingDireccion.value = false;
    editingSituacionFamiliar.value = false;
  } catch (error) {
    savingForm.value = false;
    await handleError(error);
  }
});

const handleFileUpload = () => uploader.value?.click();
const resetUploader = () => {
  if (uploader.value) uploader.value.value = "";
};
const onFileChanged = async (e) => {
  const file = e.target.files[0];

  const reader = new FileReader();
  await new Promise<void>((resolve, reject) => {
    reader.readAsDataURL(file);
    reader.onload = () => {
      documentosNuevos.value.push({
        nombre: file.name,
        data: reader.result?.toString() || "",
      });

      resolve();
    };
    reader.onerror = reject;
  });
  await submit();
  documentosNuevos.value = [];
};
const handleFileDelete = async (row) => {
  const { isConfirmed } = await Swal.fire({
    text: t("global.eliminar.confirmacion"),
    icon: "question",
    showCancelButton: true,
    confirmButtonText: t("global.buttons.aceptar"),
    cancelButtonText: t("global.buttons.cancelar"),
    reverseButtons: true,
  });

  if (!isConfirmed) return;

  documentosEliminar.value.push(row.id);
  await submit();
  documentosEliminar.value = [];
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("perfilInformacionDelAdultoResponsable")), 1),
          (!editingInformacion.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[0] || (_cache[0] = 
                () => {
                  editingInformacion.value = true;
                  editingDireccion.value = false;
                  editingSituacionFamiliar.value = false;
                }
              )
                  }, _toDisplayString(_ctx.$t("globalButtonsEditar")), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", {
                class: _normalizeClass(["fs-6 fw-semibold mt-2 mb-3", {
                'text-muted': !editingInformacion.value,
              }])
              }, _toDisplayString(_ctx.$t("perfilInformacionTratamientoLabel")), 3)
            ]),
            _createElementVNode("div", _hoisted_10, [
              (!editingInformacion.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(familiaTratamiento).text), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _withDirectives(_createElementVNode("select", {
                      name: "tratamiento",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(values).tratamiento) = $event)),
                      class: "form-select form-select-solid"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tratamientos), (tratamiento, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: tratamiento.id,
                          key: i
                        }, _toDisplayString(tratamiento.text), 9, _hoisted_12))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _unref(values).tratamiento]
                    ]),
                    _createVNode(_unref(ErrorMessage), {
                      name: "tratamiento",
                      class: "fv-plugins-message-container invalid-feedback ms-3"
                    })
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("label", {
                class: _normalizeClass(["fs-6 fw-semibold mt-2 mb-3", {
                'text-muted': !editingInformacion.value,
              }])
              }, _toDisplayString(_ctx.$t("perfilInformacionNombreLabel")), 3)
            ]),
            _createElementVNode("div", _hoisted_15, [
              (!editingInformacion.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(familia)?.nombre ?? "-"), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_unref(Field), {
                      name: "nombre",
                      class: "form-control form-control-solid"
                    }),
                    _createVNode(_unref(ErrorMessage), {
                      class: "fv-plugins-message-container invalid-feedback ms-3",
                      name: "nombre"
                    })
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("label", {
                class: _normalizeClass(["fs-6 fw-semibold mt-2 mb-3", {
                'text-muted': !editingInformacion.value,
              }])
              }, _toDisplayString(_ctx.$t("perfilInformacionApellidosLabel")), 3)
            ]),
            _createElementVNode("div", _hoisted_19, [
              (!editingInformacion.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_unref(familia)?.apellidos ?? "-"), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_unref(Field), {
                      name: "apellidos",
                      class: "form-control form-control-solid"
                    }),
                    _createVNode(_unref(ErrorMessage), {
                      class: "fv-plugins-message-container invalid-feedback ms-3",
                      name: "apellidos"
                    })
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("label", {
                class: _normalizeClass(["fs-6 fw-semibold mt-2 mb-3", {
                'text-muted': !editingInformacion.value,
              }])
              }, _toDisplayString(_ctx.$t("perfilInformacionDNILabel")), 3)
            ]),
            _createElementVNode("div", _hoisted_23, [
              (!editingInformacion.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_unref(familia)?.dni ?? "-"), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_unref(Field), {
                      name: "dni",
                      class: "form-control form-control-solid"
                    }),
                    _createVNode(_unref(ErrorMessage), {
                      class: "fv-plugins-message-container invalid-feedback ms-3",
                      name: "dni"
                    })
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("label", {
                class: _normalizeClass(["fs-6 fw-semibold mt-2 mb-3", {
                'text-muted': !editingInformacion.value,
              }])
              }, _toDisplayString(_ctx.$t("perfilInformacionEmailLabel")), 3)
            ]),
            _createElementVNode("div", _hoisted_27, [
              (!editingInformacion.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_unref(familia)?.email ?? "-"), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_unref(Field), {
                      name: "email",
                      type: "email",
                      class: "form-control form-control-solid"
                    }),
                    _createVNode(_unref(ErrorMessage), {
                      class: "fv-plugins-message-container invalid-feedback ms-3",
                      name: "email"
                    })
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("label", {
                class: _normalizeClass(["fs-6 fw-semibold mt-2 mb-3", {
                'text-muted': !editingInformacion.value,
              }])
              }, _toDisplayString(_ctx.$t("perfilInformacionTelefonoLabel")), 3)
            ]),
            _createElementVNode("div", _hoisted_31, [
              (!editingInformacion.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_unref(familia)?.telefono ?? "-"), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_unref(Field), {
                      name: "telefono",
                      class: "form-control form-control-solid"
                    }),
                    _createVNode(_unref(ErrorMessage), {
                      class: "fv-plugins-message-container invalid-feedback ms-3",
                      name: "telefono"
                    })
                  ], 64))
            ])
          ])
        ]),
        (editingInformacion.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-light btn-active-light-primary me-2",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (editingInformacion.value = false))
              }, _toDisplayString(_ctx.$t("globalButtonsDescartar")), 1),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                "data-kt-indicator": savingForm.value ? 'on' : null,
                disabled: !_unref(meta).dirty || savingForm.value,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(submit) && _unref(submit)(...args)))
              }, _toDisplayString(_ctx.$t("globalButtonsGuardarCambios")), 9, _hoisted_34)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("form", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t("perfilDireccion")), 1),
          (!editingDireccion.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[4] || (_cache[4] = 
                () => {
                  editingDireccion.value = true;
                  editingInformacion.value = false;
                  editingSituacionFamiliar.value = false;
                }
              )
                  }, _toDisplayString(_ctx.$t("globalButtonsEditar")), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("label", {
                class: _normalizeClass(["fs-6 fw-semibold mt-2 mb-3", {
                'text-muted': !editingDireccion.value,
              }])
              }, _toDisplayString(_ctx.$t("perfilDireccionDireccionLabel")), 3)
            ]),
            _createElementVNode("div", _hoisted_44, [
              (!editingDireccion.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_unref(familia)?.direccion ?? "-"), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_unref(Field), {
                      name: "direccion",
                      class: "form-control form-control-solid"
                    }),
                    _createVNode(_unref(ErrorMessage), {
                      class: "fv-plugins-message-container invalid-feedback ms-3",
                      name: "direccion"
                    })
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("label", {
                class: _normalizeClass(["fs-6 fw-semibold mt-2 mb-3", {
                'text-muted': !editingDireccion.value,
              }])
              }, _toDisplayString(_ctx.$t("DireccionLocalidadLabel")), 3)
            ]),
            _createElementVNode("div", _hoisted_48, [
              (!editingDireccion.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_unref(familia)?.localidad ?? "-"), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(localidad),
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(localidad) ? (localidad).value = $event : null)),
                      name: "localidad",
                      class: "form-select form-select-solid form-el-select",
                      filterable: "",
                      placeholder: _ctx.$t('OpcionInicialLocalidad'),
                      "suffix-icon": ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(municipios), (municipio, i) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: i,
                            value: municipio.municipioNombre
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(municipio.municipioNombre), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"]),
                    _createVNode(_unref(ErrorMessage), {
                      class: "fv-plugins-message-container invalid-feedback ms-3",
                      name: "localidad"
                    })
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("label", {
                class: _normalizeClass(["fs-6 fw-semibold mt-2 mb-3", {
                'text-muted': !editingDireccion.value,
              }])
              }, _toDisplayString(_ctx.$t("DireccionComarcaLabel")), 3)
            ]),
            _createElementVNode("div", _hoisted_52, [
              (!editingDireccion.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_unref(familia)?.comarca?.nombre ?? "-"), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _withDirectives(_createElementVNode("select", {
                      disabled: "",
                      name: "comarca",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(comarcaId) ? (comarcaId).value = $event : null)),
                      class: "form-select form-select-solid form-select-display"
                    }, [
                      _createElementVNode("option", _hoisted_54, _toDisplayString(_ctx.$t("OpcionInicialComarca")), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(comarcas), (comarca, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: comarca.id,
                          key: i
                        }, _toDisplayString(comarca.text), 9, _hoisted_55))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _unref(comarcaId)]
                    ]),
                    _createVNode(_unref(ErrorMessage), {
                      class: "fv-plugins-message-container invalid-feedback ms-3",
                      name: "comarcaId"
                    })
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("label", {
                class: _normalizeClass(["fs-6 fw-semibold mt-2 mb-3", {
                'text-muted': !editingDireccion.value,
              }])
              }, _toDisplayString(_ctx.$t("DireccionProvinciaLabel")), 3)
            ]),
            _createElementVNode("div", _hoisted_58, [
              (!editingDireccion.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(_unref(familia)?.provincia ?? "-"), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _withDirectives(_createElementVNode("select", {
                      disabled: "",
                      name: "provincia",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(provincia) ? (provincia).value = $event : null)),
                      class: "form-select form-select-solid form-select-display"
                    }, [
                      _createElementVNode("option", _hoisted_60, _toDisplayString(_ctx.$t("OpcionInicialProvincia")), 1),
                      _hoisted_61,
                      _hoisted_62,
                      _hoisted_63
                    ], 512), [
                      [_vModelSelect, _unref(provincia)]
                    ]),
                    _createVNode(_unref(ErrorMessage), {
                      class: "fv-plugins-message-container invalid-feedback ms-3",
                      name: "provincia"
                    })
                  ], 64))
            ])
          ])
        ]),
        (editingDireccion.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-light btn-active-light-primary me-2",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (editingDireccion.value = false))
              }, _toDisplayString(_ctx.$t("globalButtonsDescartar")), 1),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary",
                "data-kt-indicator": savingForm.value ? 'on' : null,
                disabled: !_unref(meta).dirty || savingForm.value,
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_unref(submit) && _unref(submit)(...args)))
              }, _toDisplayString(_ctx.$t("globalButtonsGuardarCambios")), 9, _hoisted_65)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("form", _hoisted_66, [
      _createElementVNode("div", _hoisted_67, [
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.$t("perfilSituacionFamiliar")), 1),
          (!editingSituacionFamiliar.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[10] || (_cache[10] = 
                () => {
                  editingDireccion.value = false;
                  editingInformacion.value = false;
                  editingSituacionFamiliar.value = true;
                }
              )
                  }, _toDisplayString(_ctx.$t("globalButtonsEditar")), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("label", {
                class: _normalizeClass(["fs-6 fw-semibold mt-2 mb-3", {
                'text-muted': !editingSituacionFamiliar.value,
              }])
              }, _toDisplayString(_ctx.$t("perfilSituacionFamiliarTipologiaFamiliaLabel")), 3)
            ]),
            _createElementVNode("div", _hoisted_75, [
              (!editingSituacionFamiliar.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_76, _toDisplayString(_unref(familiaTipologiaFamilia).nombre), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _withDirectives(_createElementVNode("select", {
                      name: "tipologiaFamilia",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(values).tipologiaFamilia) = $event)),
                      class: "form-select form-select-solid"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tipologiasFamiliaTodas), (tipologiaFamilia, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: tipologiaFamilia.id,
                          key: i
                        }, _toDisplayString(tipologiaFamilia.nombre), 9, _hoisted_77))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _unref(values).tipologiaFamilia]
                    ]),
                    _createVNode(_unref(ErrorMessage), {
                      name: "tipologiaFamilia",
                      class: "fv-plugins-message-container invalid-feedback ms-3"
                    })
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("label", {
                class: _normalizeClass(["fs-6 fw-semibold mt-2 mb-3", {
                'text-muted': !editingSituacionFamiliar.value,
              }])
              }, _toDisplayString(_ctx.$t("perfilSituacionFamiliarNumeroMenoresLabel")), 3)
            ]),
            _createElementVNode("div", _hoisted_80, [
              (!editingSituacionFamiliar.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString(_unref(familiaNumeroMenores).nombre), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _withDirectives(_createElementVNode("select", {
                      name: "numeroMenores",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(values).numeroMenores) = $event)),
                      class: "form-select form-select-solid"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(numeroMenoresOpcionesTodas), (numeroMenores, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: numeroMenores.id,
                          key: i
                        }, _toDisplayString(numeroMenores.nombre), 9, _hoisted_82))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _unref(values).numeroMenores]
                    ]),
                    _createVNode(_unref(ErrorMessage), {
                      name: "numeroMenores",
                      class: "fv-plugins-message-container invalid-feedback ms-3"
                    })
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("label", {
                class: _normalizeClass(["fs-6 fw-semibold mt-2 mb-3", {
                'text-muted': !editingSituacionFamiliar.value,
              }])
              }, _toDisplayString(_ctx.$t("perfilSituacionFamiliarConIngresosLabel")), 3)
            ]),
            _createElementVNode("div", _hoisted_85, [
              (!editingSituacionFamiliar.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_86, _toDisplayString(_unref(familia)?.conIngresos
                  ? _ctx.$t("SituacionFamiliarConIngresosSi")
                  : _ctx.$t("SituacionFamiliarConIngresosNo")), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select form-select-solid",
                      id: "conIngresos",
                      name: "conIngresos",
                      "aria-label": _ctx.$t('SituacionFamiliarConIngresosLabel'),
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(values).conIngresos) = $event))
                    }, [
                      _createElementVNode("option", _hoisted_88, _toDisplayString(_ctx.$t("SituacionFamiliarConIngresosSi")), 1),
                      _createElementVNode("option", _hoisted_89, _toDisplayString(_ctx.$t("SituacionFamiliarConIngresosNo")), 1)
                    ], 8, _hoisted_87), [
                      [_vModelSelect, _unref(values).conIngresos]
                    ]),
                    _createVNode(_unref(ErrorMessage), {
                      class: "fv-plugins-message-container invalid-feedback ms-3",
                      name: "conIngresos"
                    })
                  ], 64))
            ])
          ]),
          (_unref(values).conIngresos)
            ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["fs-6 fw-semibold mt-2 mb-3", {
                'text-muted': !editingSituacionFamiliar.value,
              }])
                  }, _toDisplayString(_ctx.$t("perfilSituacionFamiliarIngresosLabel")), 3)
                ]),
                _createElementVNode("div", _hoisted_92, [
                  (!editingSituacionFamiliar.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_93, _toDisplayString(_unref(familia)?.ingresos
                  ? parseFloat(_unref(familia).ingresos).toFixed(2) + "€"
                  : "-"), 1))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_94, [
                          _createVNode(CurrencyInput, {
                            modelValue: _unref(values).ingresos,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(values).ingresos) = $event)),
                            modelModifiers: { lazy: true },
                            options: {
                    currency: 'EUR',
                    locale: 'es-ES',
                    currencyDisplay: 'symbol',
                    precision: 2,
                    hideCurrencySymbolOnFocus: true,
                    hideGroupingSeparatorOnFocus: true,
                    hideNegligibleDecimalDigitsOnFocus: true,
                    autoDecimalDigits: false,
                    useGrouping: true,
                    accountingSign: false,
                  },
                            type: "text",
                            name: "ingresos",
                            class: "form-control form-control-solid"
                          }, null, 8, ["modelValue"])
                        ]),
                        _hoisted_95,
                        _createVNode(_unref(ErrorMessage), {
                          class: "fv-plugins-message-container invalid-feedback ms-3",
                          name: "conIngresos"
                        })
                      ], 64))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("div", _hoisted_97, [
              _createElementVNode("label", {
                class: _normalizeClass(["fs-6 fw-semibold mt-2 mb-3", {
                'text-muted': !editingSituacionFamiliar.value,
              }])
              }, _toDisplayString(_ctx.$t("perfilSituacionFamiliarFamiliaPrioritariaLabel")), 3)
            ]),
            _createElementVNode("div", _hoisted_98, [
              (!editingSituacionFamiliar.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_99, _toDisplayString(_unref(familia)?.familiaPrioritaria
                  ? _ctx.$t("SituacionFamiliarFamiliaPrioritariaSi")
                  : _ctx.$t("SituacionFamiliarFamiliaPrioritariaNo")), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select form-select-solid",
                      id: "familiaPrioritaria",
                      name: "familiaPrioritaria",
                      "aria-label": _ctx.$t('SituacionFamiliarConIngresosLabel'),
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(values).familiaPrioritaria) = $event))
                    }, [
                      _createElementVNode("option", _hoisted_101, _toDisplayString(_ctx.$t("SituacionFamiliarFamiliaPrioritariaSi")), 1),
                      _createElementVNode("option", _hoisted_102, _toDisplayString(_ctx.$t("SituacionFamiliarFamiliaPrioritariaNo")), 1)
                    ], 8, _hoisted_100), [
                      [_vModelSelect, _unref(values).familiaPrioritaria]
                    ]),
                    _createVNode(_unref(ErrorMessage), {
                      class: "fv-plugins-message-container invalid-feedback ms-3",
                      name: "familiaPrioritaria"
                    })
                  ], 64))
            ])
          ])
        ]),
        (editingSituacionFamiliar.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-light btn-active-light-primary me-2",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (editingSituacionFamiliar.value = false))
              }, _toDisplayString(_ctx.$t("globalButtonsDescartar")), 1),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary",
                "data-kt-indicator": savingForm.value ? 'on' : null,
                disabled: !_unref(meta).dirty || savingForm.value,
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_unref(submit) && _unref(submit)(...args)))
              }, _toDisplayString(_ctx.$t("globalButtonsGuardarCambios")), 9, _hoisted_104)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_105, [
      _createElementVNode("div", _hoisted_106, [
        _createElementVNode("div", _hoisted_107, [
          _createElementVNode("div", _hoisted_108, _toDisplayString(_ctx.$t("perfilLibroDeFamiliaYOtrosDocumentos")), 1),
          _createElementVNode("div", _hoisted_109, [
            _createElementVNode("div", _hoisted_110, [
              _createElementVNode("input", {
                ref_key: "uploader",
                ref: uploader,
                class: "d-none",
                type: "file",
                onChange: onFileChanged,
                onClick: resetUploader
              }, null, 544),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: handleFileUpload
              }, _toDisplayString(_ctx.$t("globalButtonsSubirNuevo")), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_111, [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            style: {"width":"100%"},
            stripe: "",
            data: _unref(documentos),
            "default-sort": { prop: 'nombre', order: 'ascending' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: _ctx.$t('perfilDocumentosNombreLabel'),
                sortable: "",
                prop: "nombre",
                "min-width": "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("a", {
                    download: scope.row.nombre,
                    href: scope.row.blob
                  }, _toDisplayString(scope.row.nombre), 9, _hoisted_112)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                label: _ctx.$t('perfilDocumentosFechaLabel'),
                sortable: "",
                prop: "createdOn",
                formatter: formatLongDate,
                "min-width": "150"
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                width: "60",
                fixed: "right"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_dropdown, null, {
                    dropdown: _withCtx(() => [
                      _createVNode(_component_el_dropdown_menu, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_dropdown_item, null, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                class: "menu-link px-3",
                                download: scope.row.nombre,
                                href: scope.row.blob
                              }, _toDisplayString(_ctx.$t("global.buttons.descargar")), 9, _hoisted_114)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_dropdown_item, {
                            divided: "",
                            onClick: ($event: any) => (handleFileDelete(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_115, _toDisplayString(_ctx.$t("global.buttons.eliminar")), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      _hoisted_113
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, documentosLoading.value]
          ])
        ])
      ])
    ])
  ], 64))
}
}

})